module.exports = __webpack_public_path__ + "static/media/BM7100-59H_01.9b0408d2.png";